/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadDefinitionListSortCriteria {
    getFixupPrototypeFunction() { return WorkloadDefinitionListSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<WorkloadDefinitionListSortCriteria>): WorkloadDefinitionListSortCriteria {
        let obj = Object.assign(new WorkloadDefinitionListSortCriteria(), model);
        WorkloadDefinitionListSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadDefinitionListSortCriteria>): WorkloadDefinitionListSortCriteria {
        if (!model) return null;
        return WorkloadDefinitionListSortCriteria.newInstance(<WorkloadDefinitionListSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadDefinitionListSortCriteria) {
        if (!obj) return;

        models.WorkloadDefinitionListSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadDefinitionListSortCriteria): boolean {
        Object.setPrototypeOf(obj, WorkloadDefinitionListSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.WorkloadDefinitionListSortColumn;

    ascending: boolean;

}
